<template>
<div>
    <b-container fluid class="md-content">
        <div class="md-header">Datenanfragen verwalten</div>
        <b-card>
            <b-row>
                <b-col>
                    <b-button variant="success" @click="showModal('modal-createer')">Mitarbeiter Anfrage anlegen</b-button>
                </b-col>
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="employees != undefined">
                <b-col>
                    <b-table bordered :items="employeerequests" :fields="fields">
                        <template slot="name" slot-scope="row">
                            {{row.item.data.firstName}} {{row.item.data.lastName}}
                        </template>

                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openViewModal(row.item)"><i class="fas fa-eye"></i></b-button>
                            <b-button class="mx-1" size="sm" v-on:click="openConfirmModal(row.item)" v-if="row.item.signed && row.item.valid"><i class="fas fa-link"></i></b-button>
                            <b-button class="mx-1" size="sm" v-on:click="navigateToRequest(row.item)"><i class="fas fa-pencil-alt"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row.item)"><i class="fas fa-trash"></i></b-button>
                        </template>

                    </b-table>
                </b-col>
            </b-row>
        </b-card>
    </b-container>

    <b-modal ref="modal-createer" size="lg" no-close-on-backdrop no-close-on-esc centered title="Mitarbeiter Anfrage anlegen" @cancel="hideModal('modal-createer')" @ok="createEmployeeRequest" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group label-cols="4" label-cols-lg="2" label="Mitarbeiter" label-for="eremployee">
                    <b-form-select id="eremployee" v-model="newRequest.employee">
                        <option v-bind:value="null">
                            Neuer Mitarbeiter
                        </option>
                        <option v-for="option in employees" v-bind:key="option.id" v-bind:value="option">
                            {{ option.firstName }} {{ option.lastName }}
                        </option>
                    </b-form-select>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="2" label="Email" label-for="eremail" v-if="newRequest.employee === null">
                    <b-form-input id="eremail" v-model="newRequest.email"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Link per email versenden" label-for="ercheck">
                    <b-form-checkbox id="ercheck" v-model="newRequest.sendWithEmail">

                    </b-form-checkbox>
                </b-form-group>
            </div>

            <b-row v-if="error">
                Fehler beim Erstellen der Anfrage.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-confirmer" no-close-on-backdrop no-close-on-esc centered title="Anfrage löschen" @cancel="hideModal('modal-confirmer')" @ok="confirmEmployeeRequest" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Anfrage bestätigen wollen?</p>
            </b-row>
            <b-row v-if="error">
                Fehler beim Bestätigen der Anfrage.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deleteer" no-close-on-backdrop no-close-on-esc centered title="Anfrage löschen" @cancel="hideModal('modal-deleteer')" @ok="deleteEmployeeRequest" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Anfrage löschen wollen?</p>
            </b-row>
            <b-row v-if="error">
                Fehler beim Löschen der Anfrage.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-viewemployeer" size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Mitarbeiter Anfrage Detail" @cancel="hideModal('modal-viewemployeer')" @ok="hideModal('modal-viewemployeer')" cancel-title="Abbrechen">
        <b-container fluid>
            <b-card no-body>
                <b-tabs card>
                    <b-tab title="Mitarbeiter" active>
                        <div v-if="employeeRequestMap[employeeRequestId] != undefined">
                            <b-row>
                                <b-col class="md-2">
                                    <b>Anrede:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.title}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Titel:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.prefix}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>Vorname:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.firstName}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Mädchenname:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.maidenName}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>Nachname:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.lastName}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Titel 2:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.postfix}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>Gender:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.gender}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Religion:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.religion}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>Geburtstag:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.dob}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Angestellt seit:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.employedSince}}
                                </b-col>

                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>SV-Nummer:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.socialsecurity}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Email:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.email}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>Heim-Tel.:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.homephone}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Mobil-Tel.:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.mobilephone}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>Adresse:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.address}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Stadt:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.city}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>PLZ:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.postalCode}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Land:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.country}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>Nationalität:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.nationality}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Bürger - Typ:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.citizenType}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>Führerschein:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.driverslicense}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Führerschein Ablaufdatum:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.dlExpiry}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>Erste Hilfe Kurs:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.firstaidcourse}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>Erste Hilfe Ablaufdatum:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.faExpiry}}
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="md-2">
                                    <b>IBAN:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.iban}}
                                </b-col>
                                <b-col class="md-2">
                                    <b>BIC:</b>
                                </b-col>
                                <b-col>
                                    {{employeeRequestMap[employeeRequestId].data.bic}}
                                </b-col>
                            </b-row>

                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-container>
    </b-modal>

</div>
</template>

<script>
export default {
    name: 'employeedatarequestoverview',
    props: [],
    data() {
        return {
            employees: [],
            employeerequests: [],
            employeeRequestMap: {},
            fields: [{
                key: "requestDate",
                label: "Erstell Datum",
                sortable: true
            }, {
                key: "name",
                label: "Name",
                sortable: true
            }, {
                key: "valid",
                label: "Gültig",
                sortable: true
            }, {
                key: "signed",
                label: "Unterzeichnet",
                sortable: true
            }, {
                key: "actions",
                sortable: false
            }],
            newRequest: {
                sendWithEmail: false,
                email: "",
                employee: null,
            },
            employeeRequestId: "",
            currentRequest: {},
            error: false,
        }
    },
    created: function () {
        this.refresh();
    },
    // methods that implement data logic.
    methods: {
        refresh: function () {
            let view = this;
            this.loadEmployees();
            this.loadTableData()
                .then(response => {
                    view.setOverview(response.data);
                }).catch(function (error) {
                    console.log(error)
                })
        },
        openViewModal: function(item){
            this.employeeRequestId = item.id;
            this.currentRequest = item;
           
            
            this.showModal('modal-viewemployeer');
        },
        createEmployeeRequest: function (evt) {
            evt.preventDefault();
            this.error = false;
            let view = this;
            let url = '/api/sec/employeedatarequest';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeedatarequest');
            url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/employeedatarequest');

            let payload = {
                sendWithEmail: this.newRequest.sendWithEmail,
            }
            if (this.newRequest.employee != null) {
                payload.data = this.newRequest.employee;
                payload.employeeId = this.newRequest.employee.id;
                let updateFields =[];
                for (var property in this.newRequest.employee) {
                    updateFields.push(""+property);  
                }
                payload.data.updateFields = updateFields;

            } else {
                payload.data = {
                    email: this.newRequest.email,
                    updateFields: ["email"]
                }
            }
           

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let item = response.data.data;
                item.valid = !view.$helpers.isBlank(item.data.dob) && !view.$helpers.isBlank(item.data.email) && !view.$helpers.isBlank(item.data.firstName) && !view.$helpers.isBlank(item.data.lastName);
                item.signed = !view.$helpers.isBlank(item.signature);
                view.employeerequests.push(item);
                view.employeeRequestMap[response.data.data.id] = response.data.data;
                view.hideModal('modal-createer');
            }).catch(function (error) {
                view.error = true;
                console.log(error)
            })

        },
        openConfirmModal: function (item) {
            this.currentRequest = item;

            this.employeeRequestId = item.id;
            this.showModal('modal-confirmer');
        },
        confirmEmployeeRequest: function (evt) {
            evt.preventDefault();
            this.error = false;
            let view = this;
            let url = '/api/sec/employeedatarequest/confirm';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeedatarequest/confirm');
            url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/employeedatarequest');
            url = this.$helpers.appendParam("id", this.employeeRequestId, url, '/api/sec/employeedatarequest/confirm');

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.hideModal('modal-confirmer');
            }).catch(function (error) {
                view.error = true;
                console.log(error)
            })

        },
        openDeleteModal: function (item) {
            this.currentRequest = item;

            this.employeeRequestId = item.id;
            this.showModal('modal-deleteer');
        },
        deleteEmployeeRequest: function (evt) {
            evt.preventDefault();
            this.error = false;
            let view = this;
            let url = '/api/sec/employeedatarequest';

            url = this.$helpers.appendParam("id", this.employeeRequestId, url, '/api/sec/employeedatarequest');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeedatarequest');

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then(response => {
                const index = this.employeerequests.findIndex(employeeRequest => employeeRequest.id === view.employeeRequestId)
                if (~index) {
                    view.employeerequests.splice(index, 1);
                }
                view.deleteEmployeeRequestFromMap(view.employeeRequestId);
                view.hideModal('modal-deleteer');
            }).catch(function (error) {
                view.error = true;
                console.log(error)
            })

        },
        deleteEmployeeRequestFromMap(id) {

            delete this.employeeRequestMap[id];
        },
        navigateToRequest: function (item) {
            this.$router.push({
                name: 'employeedatarequest',
                params: {
                    id: item.id,
                    token: item.token
                }
            })
        },
        loadTableData: function () {
            let url = '/api/sec/employeedatarequest';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeedatarequest');

            return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })

        },
        loadEmployees: function () {
            let url = '/api/sec/employee';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');

            return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then((result) => {
                this.employees = result.data;
            });
        },
        setOverview: function (data) {
            let overviewA = [];
            var i;
            for (i = 0; i < data.length; i++) {
                this.employeeRequestMap[data[i].id] = data[i];
                let item = data[i];
                item.valid = !this.$helpers.isBlank(item.data.dob) && !this.$helpers.isBlank(item.data.email) && !this.$helpers.isBlank(item.data.firstName) && !this.$helpers.isBlank(item.data.lastName);
                item.signed = !this.$helpers.isBlank(item.signature);

                overviewA.push(item);
            }

            this.employeerequests = overviewA;
        },
        hideModal(ref) {
            this.error = false;
            this.newRequest = {
                sendWithEmail: false,
                email: "",
                employee: null,
            };

            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        }
    },
    components: {},
    computed: {

    },
    watch: {

    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>
